export const ACCESS = {
  metrics: 'metrics',
  notifications: 'notifications',
};
